<a
  class="col-3 mx-2 card icon-card"
  [nbTooltip]="copied ? 'Copied - ' + tooltip : tooltip"
  nbTooltipStatus="default"
  [ngxClipboard]="link"
  (click)="share()"
  (mouseleave)="mouseOut()"
  (mouseenter)="mouseOut()"
>
  <div class="card-body d-flex justify-content-center align-items-center">
    <ng-content></ng-content>
  </div>
</a>
